import { timestamp } from '@edgvr-front/common/domain';
import { binaryFile } from './binaryFile';
import { binaryId } from './binaryId';
import { binaryInstance } from './binaryInstance';
import { binaryVersion } from './binaryVersion';

export const binaryEntityRaw = {
  type: 'object',
  required: ['id', 'instance', 'file', 'version', 'updatedAt'],
  properties: {
    id: binaryId,
    instance: binaryInstance,
    file: binaryFile,
    version: binaryVersion,
    updatedAt: timestamp,
  },
  additionalProperties: false,
};
